'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var zod = require('zod');

let FieldName = /*#__PURE__*/function (FieldName) {
  FieldName["email"] = "email";
  FieldName["orderNumber"] = "orderNumber";
  FieldName["claimTypeOption"] = "claimTypeOption";
  return FieldName;
}({});
const FormSchema = zod.z.object({
  email: zod.z.string().email(),
  orderNumber: zod.z.string().min(1),
  claimTypeOption: zod.z.string()
});
const useFormState = (_ref, initialValues) => {
  let {
    handleSubmit
  } = _ref;
  const [state, setState] = React.useState({
    values: {
      email: initialValues.email,
      orderNumber: initialValues.orderNumber,
      claimTypeOption: initialValues.claimTypeOption
    },
    errors: {
      email: false,
      orderNumber: false,
      claimTypeOption: false
    }
  });
  const onChange = (field, value) => {
    setState({
      errors: {
        ...state.errors,
        [field]: false
      },
      values: {
        ...state.values,
        [field]: value
      }
    });
  };
  const validateForm = () => {
    const parseResult = FormSchema.safeParse(state.values);
    if (parseResult.success) return true;
    const errorMap = Object.keys(parseResult.error.formErrors.fieldErrors).reduce((errors, fieldErrorKey) => {
      errors[fieldErrorKey] = true;
      return errors;
    }, {
      email: false,
      orderNumber: false,
      claimTypeOption: false
    });
    setState({
      values: state.values,
      errors: errorMap
    });
    return false;
  };
  const onSubmit = e => {
    e === null || e === void 0 ? void 0 : e.preventDefault();
    if (validateForm()) {
      handleSubmit(e);
    }
  };
  return {
    state,
    onChange,
    onSubmit
  };
};

exports.FieldName = FieldName;
exports["default"] = useFormState;
